var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoneyBillsSimple = function SvgMoneyBillsSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.5 3h-16A2.5 2.5 0 0 0 3 5.5V18h21V5.5A2.5 2.5 0 0 0 21.5 3M23 17H4V5.5C4 4.67 4.67 4 5.5 4h16c.83 0 1.5.67 1.5 1.5zM1 20h20v1H0V8.5c0-.81.4-1.53 1-1.99zM13.5 7C11.57 7 10 8.57 10 10.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5S15.43 7 13.5 7m0 6a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5"
  })));
};
export default SvgMoneyBillsSimple;